﻿import { createElement } from "./_dom";
import { Modal } from "./_modal";
import { initChatButton, getChatPrompts, createChatUI, initAuditChatLinks } from "../aichat/chatmenu";
import { addScript } from "./addScript";
import { getRootUrl, getBuildVersion } from "./context"; 

const nonce = document.currentScript.nonce;

function openAIChatWindow(context, apiConfig, chatOptions) {
	const rootUrl = getRootUrl();
	const { prompts, ...options } = { params: {}, ...(chatOptions ?? getChatPrompts(context, apiConfig)) };
	const fragment = createChatUI(prompts, options);
	new Modal(fragment, { class: "v3-dialog v3-openaichat__dialog" }).start();
	addScript({ src: `${rootUrl}/js/aichat.js?v=${getBuildVersion()}`, nonce }, () => { });
}

function initViewChat(context) {
	if (document.getElementById("frm_search")) {
		initChatButton((buttonTitle, apiConfig) => {
			initAuditChatLinks(context, options => openAIChatWindow(context, apiConfig, options));
			const button = createElement("button", { type: "button", class: "v3-button v3-openaichat__button ui-icon-openai", on: { click: () => openAIChatWindow(context, apiConfig) } }, createElement("span", { class: "ui-icontext" }, buttonTitle));
			document.getElementById("frm_search").before(button);
		});
	}
}

export { initViewChat as init, openAIChatWindow };
